import { isLocalSeoUser } from 'src/common/config/FunctionHelper';
import { SEOSpaceLocal } from 'src/common/config/TextMessage';

const isLocalSeo = isLocalSeoUser() || null;

export const FieldTexts = {
  locationName: 'Location Name / Business Name',
  address1: 'Address Line 1',
  address2: 'Address Line 2',
  zipcode: 'Zipcode / Postcode',
  websiteUrl: 'Website URL',
  phoneNumber: 'Phone Number'
};

export const LocationDetailsModalTexts = {
  title: 'Almost there! Let’s finish setting up your listing',
  noModalTitle: 'Let’s start setting up your listing.',
  descPart1:
    'We couldn’t pull some info from your Google listing. Adding the missing details helps SEOSpace build your local map ranking reports. ',
  descLocalSeoPart1:
    'We couldn’t pull some info from your Google listing. Adding the missing details helps LocalSEO build your local map ranking reports. ',
  descBold: 'This won’t change anything on your Google profile.',
  descPart2:
    '— it’s just for SEOSpace to generate your local rankings accurately.',
  submit: 'Submit',
  clickHere: 'Click here',
  clickHereDesc: ' to find your Google Maps URL',
  categoryTooltipText:
    'We use this to show you the most relevant competitors across your category. Pick the one that best fits your business.',
  continue: 'Continue'
};
